/* IMPORT */
import AbstractHidden from './abstract_hidden.js';
/* MAIN */
class AbstractActivation extends AbstractHidden {
}
/* EXPORT */
export default AbstractActivation;
